const auth = {
  loggedIn() {
    return window && window.localStorage && !!window.localStorage.token;
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/libs/auth.js